import React from 'react';
import { useLocation } from 'react-router-dom';
import { Box, useMediaQuery, Button, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import useRTL from 'src/hooks/useRTL';
import ImgLazyLoad from 'src/screens/WhiteLabels/Templates/shared/components/ImgLazyLoad';
import { PlayArrowOutlined } from '@mui/icons-material';
import { theme } from '../../../Template3/Template';
import { useCompanyData } from '../../contexts/DataContext';
import { useNavigate } from 'react-router-dom';
import GetImageDimensions from '../../logic/getImgDimensions';
import { PhotoPreview } from 'src/components/white-label-component/company-comp';
import { createMarkup } from '../../logic/Utils';
import { SectionTitle, SectionSubtitle, SectionParagraph } from "../../../Template3/components/SectionTitle";
// import { SectionTitle as T1SectionTitle, SectionSubtitle as T1SectionSubTitle, SectionParagraph as T1SectionParagraph } from '../../../Template1/components/SectionTitle';
// import { SectionTitle as T2SectionTitle, SectionSubtitle as T2SectionSubTitle, SectionParagraph as T2SectionParagraph } from '../../../Template2/components/SectionTitle';
// import { SectionTitle as T3SectionTitle, SectionSubtitle as T3SectionSubTitle, SectionParagraph as T3SectionParagraph } from '../../../Template3/components/SectionTitle';
// import { SectionTitle as T4SectionTitle, SectionSubtitle as T4SectionSubTitle, SectionParagraph as T4SectionParagraph } from '../../../Template4/components/SectionTitle';
import PlayButtonIcon from 'src/assets/images/company booking/playbutton.svg';
import SectionLayout from '../../layout/SectionLayout';
import BgImg from 'src/assets/images/website-sections/content8Bg.png';
import { textVariant, textClasses } from '../../config';
import { staticText2 } from './config';
import '../../../shared/styles.css'

const useStyles = makeStyles((theme) => ({
    aboutImg:props => ({
        '& img':{
            '@media (max-width:720px)':{
                boxShadow: props.imageShadow ? (props?.imageShadowContent ? props?.imageShadowContent : props?.itemShadow || '0px 0px 30px rgb(209,209,209)') : 'none',
                "-webkit-box-shadow": props.imageShadow ? (props?.imageShadowContent ? props?.imageShadowContent : props?.itemShadow || '0px 0px 30px rgb(209,209,209)') : 'none',
                "-moz-box-shadow": props.imageShadow ? (props?.imageShadowContent ? props?.imageShadowContent : props?.itemShadow || '0px 0px 30px rgb(209,209,209)') : 'none',
            }
        },

        boxShadow: props.imageShadow ? (props?.imageShadowContent ? props?.imageShadowContent : props?.itemShadow || '0px 0px 30px rgb(209,209,209)') : 'none',
        "-webkit-box-shadow": props.imageShadow ? (props?.imageShadowContent ? props?.imageShadowContent : props?.itemShadow || '0px 0px 30px rgb(209,209,209)') : 'none',
        "-moz-box-shadow": props.imageShadow ? (props?.imageShadowContent ? props?.imageShadowContent : props?.itemShadow || '0px 0px 30px rgb(209,209,209)') : 'none',
        '@media (max-width:720px)':{
            boxShadow: 'none',
            "-webkit-box-shadow":  'none',
            "-moz-box-shadow": 'none',
        }
    }),

    tp:{
        whiteSpace: 'pre-line',
        overflowWrap: 'break-word',
        wordBreak: 'break-word',
        fontFamily:"'Cairo', sans-serif"
    },

    playBtn:{
        position: 'absolute',
        margin: 'auto',
        width: '100%',
        height: '100%',
        cursor:'pointer',
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        justifyContent:'center',
    },

    playBtnWrapper:{
        width:'97px',
        height:'97px',

        '& img':{
            width:'100%',
            height:'100%'
        }
    }
}));

// const TitleList = {
//     '1': T1SectionTitle,
//     '2': T2SectionTitle,
//     '3': T3SectionTitle,
//     '4': T4SectionTitle,
// };

// const SubTitleList = {
//     '1': T1SectionSubTitle,
//     '2': T2SectionSubTitle,
//     '3': T3SectionSubTitle,
//     '4': T4SectionSubTitle,
// };

// const ParagraphTitleList = {
//     '1': T1SectionParagraph,
//     '2': T2SectionParagraph,
//     '3': T3SectionParagraph,
//     '4': T4SectionParagraph
// };

const fontFamilyList = {
    '1': "'Nunito Sans', sans-serif",
    '2': "'Roboto', sans-serif",
    '3': "'Poppins', sans-serif",
    '4': "'Nunito Sans', sans-serif",
};

const Content8 = (props) => {
    const [imageDimensions, setImageDimensions] = React.useState({});
    const [previewDialog, setPreviewDialog] = React.useState(false);
    const { data } = useCompanyData();
    const { companyDomain, isRTL, companyData, themeDesign } = data;
    const { pathname:url } = useLocation();
    const { contentData, index } = props;
    const [, , themeFontFamily] = useRTL('',fontFamilyList?.[themeDesign]);

    const matches720 = useMediaQuery('(min-width:720px)');
    const matches = useMediaQuery(theme.breakpoints.up('lg'));
    const mobileView = useMediaQuery(theme.breakpoints.down('md'));
    const navigate = useNavigate();
    const { buttonColor, buttonFontColor, buttonFontSize, autoButtonSize, buttonWidth, buttonHeight, sectionBackgroundColor, sectionPaddingTop, sectionPaddingBottom, sectionPaddingLeft, sectionPaddingRight,
        itemShadow, imgRadiusGeneral,buttonRadiusGeneral,
        // sectionFontColor,
        generalTitleFontSize, generalSubTitleFontSize, generalParagraphFontSize,
        generalTitleColor, generalSubTitleColor, generalParagraphColor,
        chatgptContent
    } = data || {};
    const { imageShadow=true, spaceBetweenContent, textBackground, textBorder, textRadius, imageAlt, imageShadowContent, imageRadius, imageBorder, direction, buttonBorder } = contentData || {};
    const _buttonColor = contentData?.buttonColor ? contentData?.buttonColor : '#FFFFFF';
    const _buttonFontColor = contentData?.buttonFontColor ? contentData?.buttonFontColor : '#646CFD';
    const _buttonFontSize = contentData?.buttonFontSize ? contentData?.buttonFontSize : buttonFontSize ? buttonFontSize : '18';
    const _buttonWidth = contentData?.autoButtonSize || autoButtonSize ? 'fit-content' : contentData?.buttonWidth ? `${contentData?.buttonWidth}px` :
    '200px';
    const _buttonHeight = contentData?.autoButtonSize || autoButtonSize ? 'unset' : contentData?.buttonHeight ? `${contentData?.buttonHeight}px` :
    '50px';
    const classes = useStyles({itemShadow,imageShadow,imageShadowContent,direction});
    
    React.useEffect(() => {
        GetImageDimensions(setImageDimensions, contentData?.image);
    }, [contentData?.image]);

    const buttonEvent = () => {
        if(contentData?.path) {
            var _path = url?.split('/temp')[0];
            navigate(companyDomain ? `/temp/${contentData?.path}` : `${_path}/temp/${contentData?.path}`)
        }
        else{
            window.open(contentData?.externalLink,'_blank')
        }
    };

    const closeDialog = () => {
        setPreviewDialog(false);
    }

    const chatgptTitle = chatgptContent ? (isRTL === 'ar' ? chatgptContent?.['arabic']?.[`section${index}`]?.['title'] : chatgptContent?.['english']?.[`section${index}`]?.['title']) : '';
    const chatgptSubTitle = chatgptContent ? (isRTL === 'ar' ? chatgptContent?.['arabic']?.[`section${index}`]?.['subtitle'] : chatgptContent?.['english']?.[`section${index}`]?.['subtitle']) : '';
    const chatgptDesc = chatgptContent ? (isRTL === 'ar' ? chatgptContent?.['arabic']?.[`section${index}`]?.['description'] : chatgptContent?.['english']?.[`section${index}`]?.['description']) : '';

    const title = chatgptTitle ? chatgptTitle : isRTL === 'ar' && contentData?.arTitle ? contentData?.arTitle?.trim() : contentData?.title?.trim() || staticText2?.title;
    const subTitle = chatgptSubTitle ? chatgptSubTitle : isRTL === 'ar' && contentData?.arSubTitle ? contentData?.arSubTitle?.trim() : contentData?.subTitle?.trim() || staticText2?.subTitle;
    const description = chatgptDesc ? chatgptDesc : isRTL === 'ar' && contentData?.arDescription ? contentData?.arDescription : contentData?.description || staticText2?.description;
    const buttonTitle = isRTL === 'ar' && contentData?.arButtonTitle ? contentData?.arButtonTitle : contentData?.buttonTitle || staticText2?.buttonTitle;

    const textAlign = !mobileView ? contentData?.direction === 'left' && isRTL === 'en' ? 'left' : 
                        contentData?.direction === 'left' && isRTL === 'ar' ? 'right' :
                        contentData?.direction === 'right' && isRTL === 'en' ? 'left' :
                        contentData?.direction === 'right' && isRTL === 'ar' ? 'right' : 'center' : 'center';
    
    const pTop = contentData?.paddingTop ? contentData?.paddingTop : sectionPaddingTop ? sectionPaddingTop : '80';
    const pBottom = contentData?.paddingBottom ? contentData?.paddingBottom : sectionPaddingBottom ? sectionPaddingBottom : '80';

    const imgRadius = imageRadius ? `${imageRadius}px` : '10px'; 
    const btnRadius = contentData?.buttonRadius ? `${contentData?.buttonRadius}px` : '5px'; 

    const spaceBtwMargin = contentData?.direction === 'left' ? `0px ${spaceBetweenContent}px 0px 30px` :
    contentData?.direction === 'right' ? `0px 30px 0px ${spaceBetweenContent}px` : '0px 30px';

    const titleFontSize = contentData?.titleFontSize ? contentData?.titleFontSize : 48;
    const subTitleFontSize = contentData?.subTitleFontSize ? contentData?.subTitleFontSize : 24;
    const descriptionFontSize = contentData?.descriptionFontSize ? contentData?.descriptionFontSize : 18;

    const titleFontColor = contentData?.titleFontColor ? contentData?.titleFontColor : '#FFFFFF';
    const subTitleFontColor = contentData?.subTitleFontColor ? contentData?.subTitleFontColor : '#FFFFFF';
    const descFontColor = contentData?.textFontColor ? contentData?.textFontColor : '#FFFFFF';
    const position = 'left';
    // const TitleComponent = TitleList?.[themeDesign];
    // const SubTitleComponent = SubTitleList?.[themeDesign];
    // const ParagraphTitleComponent = ParagraphTitleList?.[themeDesign];
    return (
        <Box
            width="100%"
            dir="ltr"
            bgcolor="transparent"
            position="relative"
        >
            <SectionLayout
                paddingLeft={sectionPaddingLeft}
                paddingRight={sectionPaddingRight}
                paddingTop={pTop}
                paddingBottom={pBottom}
            >
                <Box
                sx={{
                    background: contentData?.backgroundStyle === 'image' && contentData?.backgroundImage ? 
                    `url(${contentData.backgroundImage}) no-repeat center / cover`
                    : contentData?.backgroundStyle === 'gradient' && contentData?.backgroundColor ? 
                        contentData?.backgroundColor
                    : contentData?.backgroundStyle === 'solidColor' && contentData?.backgroundColor ?
                    contentData.backgroundColor
                    : `url(${BgImg}) no-repeat center / cover`,
                    position: "relative",
                    // backgroundImage: `url(${BgImg})`,
                    // backgroundSize: "cover",
                    // backgroundPosition: "center",
                    borderRadius: "0px",
                    minHeight:'649px'
                }}
                >
                      <Box
                sx={{
                    position: "absolute",
                    bottom: "-70px", // ✅ offset it DOWN from bottom edge of bg image
                    backgroundColor: "#4f8ef7",
                    color: "#fff",
                    maxWidth: 'calc(519px - 64px)',
                    width: "100%",
                    borderRadius: 1,
                    boxShadow:'3px 3px 30px #0000002E',
                    p: 4,
                    display:'flex',
                    flexDirection:'column',
                    justifyContent:contentData?.alignment || 'center',
                    left: contentData?.direction === "center" ? "50%" : contentData?.direction  === "right" ? "auto" : "90px",
                    right: contentData?.direction  === "right" ? "90px" : "auto",
                    minHeight:"calc(507px - 64px)",
                    ...(contentData?.direction === 'center' ? {transform:'translateX(-50%)'} : {}) 
                }}
            >
                {title ?
                    <Box
                        display={matches ? 'block' : 'flex'}
                        flexDirection="column"
                        alignItems="center"
                    >
                        <SectionTitle {...(titleFontColor ? {color: titleFontColor} : {} )} pb="0px" pFontSize={titleFontSize} wordBreak="break-word" textAlign={textAlign} {...([1,4]?.includes(themeDesign) ? {contentSection: true } : {} )}>{title}</SectionTitle>
                    </Box>
                : null}

                {subTitle ?
                    <Box display={matches ? 'block' : 'flex'} flexDirection="column" alignItems="center">
                        <SectionSubtitle {...(subTitleFontColor ? {color: subTitleFontColor} : {} )} pb="32px" pFontSize={subTitleFontSize} wordBreak="break-word" visibleHorizontalLine={false} textAlign={textAlign} display="block" style={themeDesign === 3 && isRTL === 'ar' ? {flexDirection: 'row-reverse'} : {}}>{subTitle}</SectionSubtitle>
                    </Box>
                : null}

                <Box pb={'43px'} dir={isRTL === 'ar' ? 'rtl' : 'ltr'} textAlign={matches ? contentData?.direction ? textAlign : '' : 'center'}>
                    <SectionParagraph
                        {...(descFontColor ? {color: descFontColor} : {} )}
                        pFontSize={descriptionFontSize}
                        description={createMarkup(description)}
                    />
                </Box>

                {contentData?.button ?
                    <Box textAlign={matches ? contentData?.direction ? textAlign : '' : 'center'}>
                        <CustomButton
                        style={{
                            backgroundColor: _buttonColor,
                            textTransform:'capitalize',
                            color: _buttonFontColor,
                            width: _buttonWidth,
                            height: _buttonHeight,
                            borderRadius: btnRadius,
                            fontFamily: 'inherit',
                            ...(buttonBorder ? {border:buttonBorder} : {})
                        }}
                        onClick={buttonEvent}
                        className={textClasses?.[_buttonFontSize]}
                        >
                        {buttonTitle}
                        </CustomButton>
                    </Box>
                : null
                }
            </Box>
                </Box>
            </SectionLayout>
        </Box>
//         <Box width="100%" dir="ltr" bgcolor="transparent">
//   <SectionLayout paddingLeft={sectionPaddingLeft} paddingRight={sectionPaddingRight} paddingTop={pTop} paddingBottom={pBottom}>
    
//     <Box position="relative">
//       {/* Background image */}
//       <Box
//         component="img"
//         src={BgImg}
//         alt=""
//         sx={{
//           width: "100%",
//           height: "auto",
//           display: "block",
//           borderRadius: "8px"
//         }}
//       />

//       {/* Blue box */}
//       <Box
//         sx={{
//           position: "absolute", // ✅ Place absolutely within image
//             top: 170,
//             left: position === "center" ? "50%" : position === "right" ? "auto" : "70px",
//             right: position === "right" ? "70px" : "auto",
//             transform: position === "center" ? "translateX(-50%)" : "none",
//             backgroundColor: "#4f8ef7",
//             color: "#fff",
//             maxWidth: 400,
//             width: "calc(100% - 64px)",
//             borderRadius: 1,
//             minHeight:"calc(507px - 64px)",
//             boxshadow:'3px 3px 30px #0000002E',
//             p: 4,
//             display:'flex',
//             flexDirection:'column',
//             justifyContent:'center',
//             // alignItems:'center'
//         }}
//       >
//         <Typography variant="h5" fontWeight="bold" gutterBottom>
//           Build your Career
//         </Typography>
//         <Typography variant="subtitle1" gutterBottom>
//           Find your best course with us
//         </Typography>
//         <Typography variant="body2" mb={3}>
//           Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Book marks grove right at the coast of the Semantics, a large language ocean.
//         </Typography>
//         <Button
//           variant="contained"
//           sx={{ backgroundColor: "white", color: "#4f8ef7" }}
//         >
//           Learn More
//         </Button>
//       </Box>
//     </Box>

//   </SectionLayout>
// </Box>
    //     <Box
    //         width="100%"
    //         dir="ltr"
    //         bgcolor={'transparent'}
    //     >
    //         <SectionLayout
    //             paddingLeft={sectionPaddingLeft}
    //             paddingRight={sectionPaddingRight}
    //             paddingTop={pTop}
    //             paddingBottom={pBottom}
    //         >
    //             <Box
    //     sx={{
    //          position: "relative", // ✅ Make image container relative
    //       backgroundImage: `url(${BgImg})`,
    //       backgroundSize: "cover",
    //       backgroundPosition: "center",
    //       borderRadius: "8px",
    //       minHeight: "649px",
    //       paddingBottom: { xs: 400, md: 300 },
    //     }}
    //   >
    //      <Box
    //       sx={{
            // position: "absolute", // ✅ Place absolutely within image
            // top: 170,
            // left: position === "center" ? "50%" : position === "right" ? "auto" : "70px",
            // right: position === "right" ? "70px" : "auto",
            // transform: position === "center" ? "translateX(-50%)" : "none",
            // backgroundColor: "#4f8ef7",
            // color: "#fff",
            // maxWidth: 400,
            // width: "calc(100% - 64px)",
            // borderRadius: 1,
            // minHeight:"calc(507px - 64px)",
            // p: 4,
            // mb: 4,
    //       }}
    //     >
    //       <Typography variant="h5" fontWeight="bold" gutterBottom>
    //         Build your Career
    //       </Typography>
    //       <Typography variant="subtitle1" gutterBottom>
    //         Find your best course with us
    //       </Typography>
    //       <Typography variant="body2" mb={3}>
            // Far far away, behind the word mountains, far from the countries
            // Vokalia and Consonantia, there live the blind texts. Separated they
            // live in Book marks grove right at the coast of the Semantics, a
            // large...
    //       </Typography>
    //       <Button
    //         variant="contained"
    //         sx={{ backgroundColor: "white", color: "#4f8ef7" }}
    //       >
    //         Learn More
    //       </Button>
    //     </Box>
    //   </Box>
    //         </SectionLayout>
    //     </Box>
    );
};

const CustomButton = ({ children, ...props }) => {
    return (
      <Button size="large" variant="contained" color="primary" {...props}>
        {children}
      </Button>
    );
};

export default Content8;